import React, { useEffect, useRef, useState } from 'react'
import ReactCrop, { centerCrop, convertToPercentCrop, convertToPixelCrop, makeAspectCrop } from 'react-image-crop';
import { useDebounceEffect } from './useDebounceEffect';
import setCanvasPreview from './setCanvasPreview';
import { useTranslation } from 'react-i18next';

const MIN_DIMENSION = 200;
const SCALE = 1;
const ROTATE = 0;
const ASPECT_RATIO = 1;

const CustomCropImage = (props) => {
    const { setNewImage, imageUrl, isNewImageSelected, setImageUrl } = props;
    const { t } = useTranslation()

    const [crop, setCrop] = useState({
        unit: 'px',
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    const previewCanvasRef = useRef(null);
    const imgRef = useRef(null);
    const [completedCrop, setCompletedCrop] = useState({
        unit: 'px',
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    const [imageCropped, setImageCropped] = useState('');

    useEffect(() => {
        if (imageCropped) {
            setNewImage(imageCropped);
        }
    }, [imageCropped]);

    function onImageLoad(e) {
        const { width, height } = e.currentTarget
        const cropA = centerCrop(
            makeAspectCrop(
                {
                    unit: '%',
                    width: 50,
                },
                ASPECT_RATIO,
                width,
                height
            ),
            width,
            height
        )
        setCrop(cropA)
        setCanvasPreview(
            imgRef.current,
            previewCanvasRef.current,
            convertToPixelCrop(
                cropA,
                width,
                height,
            )
        );
        const pixelCrop = convertToPixelCrop(cropA, width, height);
        setCompletedCrop(pixelCrop);
    }

    useDebounceEffect(
        async () => {
            if (
                completedCrop?.width &&
                completedCrop?.height &&
                imgRef.current &&
                previewCanvasRef.current
            ) {
                setCanvasPreview(
                    imgRef.current,
                    previewCanvasRef.current,
                    completedCrop,
                );
            }
            if (previewCanvasRef.current) {
                setImageCropped(previewCanvasRef.current.toDataURL());
            }
        },
        100,

        [completedCrop]
    );

    return (

        <>
            {isNewImageSelected &&
                <div>
                    {imageUrl && (
                        <div className='grid grid-cols-12 sm:gap-x-10'>
                            <div className='col-span-12 sm:col-span-6'>
                                <p>{t('common.original-image')}</p>
                                <div className='w-full h-[200px] sm:flex flex-shrink justify-center items-center sm:bg-slate-300 mt-5 rounded'>
                                    <ReactCrop
                                        crop={crop}
                                        onChange={(pixelCrop, percentCrop) => setCrop(pixelCrop)}
                                        keepSelection
                                        onComplete={(pixelCrop, percentCrop) => setCompletedCrop(pixelCrop)}
                                        aspect={ASPECT_RATIO}
                                        minHeight={50}
                                    >
                                        <img
                                            ref={imgRef}
                                            alt="Avatar"
                                            src={imageUrl}
                                            onLoad={onImageLoad}
                                            style={{ transform: `scale(${SCALE}) rotate(${ROTATE}deg)` }}
                                            className='!max-w-72 !max-h-[200px] h-auto w-auto'
                                        />
                                    </ReactCrop>
                                </div>
                            </div>

                            <div className='col-span-12 sm:col-span-6'>
                                <p>{t('common.result-image')}</p>
                                <div className=' mt-4'>

                                    <canvas
                                        ref={previewCanvasRef}
                                        style={{
                                            objectFit: 'cover',
                                            height: 200,
                                            borderRadius: "4px"
                                        }}
                                    />

                                </div>
                            </div>
                        </div>
                    )}
                </div >
                // :
                // props.showBeginImage ?
                //     <div className='p-1 border-[1px] border-[#E5E7EB] rounded inline-block'>
                //         <img src={props.imageUrl} alt="picture_profile" className='w-auto h-[200px]' />
                //     </div>
                //     :
                //     <></>
            }
        </>
    )
}

export default CustomCropImage